// 도메인별 설정
export const getConfig = () => {
    // 빌드 최적화를 방지하기 위해 명시적으로 런타임에 평가되도록 함
    // window.location을 직접 참조하지 않고, 함수를 통해 접근
    const getHostname = () => {
        try {
            if (typeof window !== 'undefined' && window.location && window.location.hostname) {
                return window.location.hostname;
            }
        } catch (e) {
            // SSR 환경 등에서 에러 방지
        }
        return '';
    };

    const hostname = getHostname();

    // reception 서브도메인 또는 ?mode=reception 쿼리 파라미터인 경우
    const isReceptionMode = (hostname && hostname.includes('reception.')) ||
        (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('mode') === 'reception');
    if (isReceptionMode) {
        return {
            // 리셉션 설정
            date: {
                ko: '26년 3월 7일 토요일 오전 11시 ~ 오후 3시',
                ja: '2026年3月7日（土）午前11時～午後3時',
            },
            dateShort: {
                ko: '3월 7일 오전 11시 ~ 오후 3시',
                ja: '3月7日 午前11時～午後3時',
            },
            place: {
                ko: '수협 태안지점 지하',
                ja: '瑞山水協泰安支店 地下',
            },
            address: {
                ko: '충남 태안군 태안읍 동백로 289\n수협 태안지점 지하',
                ja: '忠南泰安郡泰安邑冬柏路289\n瑞山水協泰安支店 地下',
            },
            // 지도 좌표
            mapLat: 36.749101,
            mapLng: 126.302259,
            mapName: '수협 태안지점',
            // 카운트다운 날짜 (시작 시간 사용)
            countdownDate: '2026-03-07T11:00:00',
            // 캘린더 월/년
            calendarMonth: 3,
            calendarYear: 2026,
            calendarSelectedDate: 7,
            // UI 표시 옵션
            showTransportInfo: false,
            showNotice2: false,
            showLanguageButton: false,
            showGiftSection: true,
            isReception: true, // reception 모드 플래그
        };
    }

    // 기본 설정 (shka-eunchan.com)
    return {
        date: {
            ko: '26년 3월 14일 토요일 오후 12:30',
            ja: '2026年3月14日（土）午後12時30分',
        },
        dateShort: {
            ko: '3월 14일 오후 12:30',
            ja: '3月14日（土） 午後12時30分',
        },
        place: {
            ko: '트라디노이 본관',
            ja: 'TRA DI NOI 本館 6F',
        },
        address: {
            ko: '서울 강남구 도곡로 99길 16, 6층',
            ja: 'ソウル市江南区道谷路99キル16、6階',
        },
        mapLat: 37.501820,
        mapLng: 127.066022,
        mapName: '트라디노이',
        countdownDate: '2026-03-14T12:00:00',
        calendarMonth: 3,
        calendarYear: 2026,
        calendarSelectedDate: 14,
        // UI 표시 옵션
        showTransportInfo: true,
        showNotice2: true,
        showLanguageButton: true,
        showGiftSection: true,
        isReception: false, // 기본 모드
    };
};
